<script>
    import IconGame from '@/components/icon/IconGame.vue';
    import constants from '@/constants/index.js';

    export default {
        data() {
            return {
                constants: constants,
            }
        },
        computed: {
            // Same badge as Corporate Requests: a number here means work waits.
            disputesCount() { return this.$store.getters.DISPUTES_COUNT },
            badge() { return this.disputesCount > 999 ? '999+' : String(this.disputesCount) },
        },
        components: {
            ButtonIcon: IconGame,
        }
    }
</script>


<template>
    <router-link 
        class="left_button_main_container button_with_badge"
        :to="{name: constants.ROUTER_NAME.GUPUPLOADS}"    
    >
        <div class="left_button_icon_container">
            <ButtonIcon 
                iconWidth = "16px"
                iconHeight = "16px"
            />
        </div>
        <div class="left_button_label_container">
            <label class="cursor_pointer">GUP uploads</label>
        </div>
        <span v-if="disputesCount > 0" class="badge_count" title="Спорных картинок ждёт разбора">{{ badge }}</span>
    </router-link>
</template>

<style scoped>
.button_with_badge {
    position: relative;
}

.badge_count {
    position: absolute;
    top: -6px;
    right: -6px;
    display: flex;
    align-items: center;
    justify-content: center;
    min-width: 20px;
    height: 20px;
    padding: 0 6px;
    background: #ff9800;
    color: white;
    border-radius: 10px;
    font-size: 11px;
    font-weight: 600;
    line-height: 1;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
}
</style>
